import React from 'react'

interface IDetailsRowProps {
  title: string
  value: React.ReactNode
}

const DetailsRow = ({ title, value }: IDetailsRowProps): JSX.Element => {
  return (
    <div style={{
      fontSize: 14,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 16,
      width: '100%'
    }}>
      <span style={{ color: '#747894', fontWeight: 400 }}>{title}</span>
      <span style={{ color: '#20242d', fontWeight: 500, textAlign: 'right' }}>{value}</span>
    </div>
  )
}

export default DetailsRow
